import React, { useState, useEffect } from 'react';
import { Title, Button, Field, Control, Notification, Card, Delete } from "rbx";
import { Link, Redirect } from "react-router-dom";
import PdvService from '../../../services/pdv';
import UserModalList from '../../components/UserModalList';
import { unMask } from '../../../commons/masks';
import { cpfOrCnpjValidate } from '../../../commons/validates';
import { searchTypes } from '../../../commons/constants';
import Controls from '../../components/Controls/Controls';

const PdvFindForm = () => {
  const [search, setSearch] = useState('');
  const [searchType, setSearchType] = useState('cpf_cnpj');
  const [usersFound, setUsersFound] = useState([]);

  const [status, setStatus] = useState('');
  const [redirectToPdv, setRedirectToPdv] = useState('');
  const [stateButton, setStateButton] = useState('');
  const [activeModal, setActiveModal] = useState(false);

  useEffect(() => {
    PdvService.cleanPdvCache();
  }, [])

  if (redirectToPdv) 
    return <Redirect to={{pathname: "/pdv"}}/>;

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setStateButton("loading");
    try {
      const validate = cpfOrCnpjValidate(search);
      if (searchType==='cpf_cnpj' && !validate[0]) {
        setStatus(['danger', validate[1]]);
      } else {
        const response = await PdvService.findBy(searchType, searchType==='cpf_cnpj' ? unMask(search) : search);
        if (response.data.pdvs.length === 0) {
          setStatus(['danger', 'PDV não encontrado.']);
        } else if (response.data.pdvs.length === 1) {
          selectUser(response.data.pdvs[0]);
        } else {
          setActiveModal(true);
          setUsersFound(response.data.pdvs);
        }
      }
    } catch(e) {
      if (e.response) 
        setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
      else
        setStatus(['danger', `${e.message}`]);
    }
    setStateButton('');
  }

  const selectUser = (user) => {
    PdvService.selectUser(user);
    setActiveModal(false);
    setRedirectToPdv(true);
  }

  const handleChangeSearchType = (evt) => {
    setSearch('');
    setStatus('');
    setSearchType(evt.target.value);
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Card>
          <Card.Content>
            { status!=='' && <Notification color={status[0]}><Delete onClick={()=>setStatus('')}/>{status[1]}</Notification> }
            <Title subtitle className="has-text-grey has-text-centered has-text-weight-medium">Localize ou registre um PDV</Title>
            <Controls.SelectField
              name="searchType"
              value={searchType}
              onChange={handleChangeSearchType}
              options={searchTypes}
              required
            />
            {
              (searchType==='cpf_cnpj') ?
                <Controls.CpfCnpjField 
                  name="search"
                  placeholder={`Localize por ${searchTypes.find(obj => obj.value===searchType)?.description||'...'}`}
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  focus={true}
                  className="has-text-centered"
                  required
                />
              :
                <Controls.TextField 
                  name="search"
                  placeholder={`Localize por ${searchTypes.find(obj => obj.value===searchType)?.description||'...'}`}
                  pattern={searchTypes.find(obj => obj.value===searchType)?.pattern||''}
                  title={searchTypes.find(obj => obj.value===searchType)?.title||''}
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  focus={true}
                  className="has-text-centered"
                  required
                />
            }
            <Field>
              <Control>
                <Button className="has-text-weight-medium" state={stateButton} color="custom-purple" fullwidth>Localizar PDV</Button>
              </Control>
            </Field>
            <div className="has-text-grey" style={{"text-align": "center", "margin-bottom": ".5rem"}}>ou</div>
            <Field>
              <Control>
                <Link to={`/pdv/new/${searchType==='cpf_cnpj' ? unMask(search) : ''}`} className="button is-fullwidth has-text-custom-purple has-text-weight-medium is-outlined">
                  Registrar
                </Link>
              </Control>
            </Field>
          </Card.Content>
        </Card>
      </form>
      <UserModalList activeModal={activeModal} setActiveModal={setActiveModal} listUsers={usersFound} selectUser={selectUser} userType="PDV" />
    </>
  )

}

export default PdvFindForm;
